import { Button } from '../cdl/Button/Button';
import { useDrawer } from '../cdl/Drawer/useDrawer.hook';
import { Text } from '../cdl/Text/Text';
import { CustomerGroupMultiSelect } from '../common/form-elements/CustomerGroupSelect/CustomerGroupMultiSelect';
import { translate } from '../common/helpers/translate.helper';
import { useDocumentTitle } from '../common/hooks/useDocumentTitle';
import { useRole } from '../common/hooks/useRole';
import { IconPlus } from '../common/icons/cdl/Plus';
import { Page } from '../common/Page/Page';
import { DebouncedSearchTextInput } from '../common/Search/DebouncedSearchTextInput/DebouncedSearchTextInput';
import { Box } from '../common/ui/Box';

import { useNavigate, useSearch } from '@tanstack/react-router';
import { PageGrid } from '../common/PageGrid';
import { CreateKeyPortForm } from './CreateKeyPortForm';
import { KeyPortOverviewTable } from './KeyPortOverviewTable';

export const KeyPortOverviewPage = () => {
    useDocumentTitle(translate('keyPorts.overviewPageTitle'));

    const { push, pop } = useDrawer();
    const role = useRole();

    const navigate = useNavigate({ from: '/key-ports' });
    const search = useSearch({ strict: false });

    const openCreateModal = () => {
        const drawerId = push({
            header: { title: translate('keyPorts.addKeyPort') },
            content: <CreateKeyPortForm onSuccess={() => pop(drawerId)} />,
        });
    };

    return (
        <Page>
            <PageGrid>
                <Box display="flex" justifyContent="space-between" alignItems="center" gap={16}>
                    <Text variant="headline" as="h1">
                        {translate('keyPorts.overviewPageTitle')}
                    </Text>

                    {role.hasWriteRights() ? (
                        <Button emphasis="high" LeadingIcon={IconPlus} onClick={openCreateModal}>
                            {translate('keyPorts.addKeyPort')}
                        </Button>
                    ) : null}
                </Box>

                <Box display="flex" alignItems="center" gap={8}>
                    <Box minWidth="250px">
                        <DebouncedSearchTextInput
                            placeholder={translate('keyPorts.searchInputPlaceholder')}
                            onChange={(searchQuery) =>
                                navigate({ search: (previousSearch) => ({ ...previousSearch, searchQuery, page: 0 }) })
                            }
                            value={search.searchQuery}
                        />
                    </Box>

                    {role.isSuperAdmin() ? (
                        <Box minWidth="250px">
                            <CustomerGroupMultiSelect
                                onChange={(customerGroupIds) =>
                                    navigate({
                                        search: (previousSearch) => ({ ...previousSearch, customerGroupIds, page: 0 }),
                                    })
                                }
                                value={search.customerGroupIds}
                                placeholder={translate('customerGroupSelect.filterByCustomerGroups')}
                                clearSearchOnSelect={false}
                                dropdownWidth="520px"
                            />
                        </Box>
                    ) : null}
                </Box>

                <KeyPortOverviewTable />
            </PageGrid>
        </Page>
    );
};
